module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318979.cba1d521.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318979.pdf
// module id = 843
// module chunks = 0